import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import StopCircle from '@mui/icons-material/StopCircle';
import type { ButtonProps } from '@mui/material/Button';

interface CancelButtonProps extends Omit<ButtonProps, 'children'> {
  label?: string;
  tooltipLabel?: string;
}

export default function CancelButton({
  label = 'Cancel',
  tooltipLabel,
  ...rest
}: CancelButtonProps) {
  return (
    <Tooltip arrow title={tooltipLabel ? tooltipLabel : ''}>
      <span>
        <Button
          {...rest}
          variant="contained"
          startIcon={<StopCircle />}
          sx={{
            width: '116.75px',
            textTransform: 'none',
            ml: '8px',
            height: 40,
            ...rest.sx,
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
